import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'parseValues',
})
export class ParseValuesPipe implements PipeTransform {
  transform(value: any): any[] {
    if (!value) return [];
    const headers: any = { ...value };
    delete headers.Action;
    return Object.values(headers);
  }
}
